import { requestWithQuery } from '../../../shared/api/utils/provider';
import { ApiResponse } from '../../../shared/api/utils/responseTransform';
import { EventListItem, EventsQueryParams } from '../../types/events';

export async function getEvents(rideSlug: string, query: EventsQueryParams): Promise<ApiResponse<EventListItem>> {
  return requestWithQuery({ url: `/care/rides/${rideSlug}/events`, method: 'GET', params: query });
}
